import React, {Suspense} from 'react';
import styles from './Home.module.css';
import Cover from '../Components/Cover';
import AboutUs from '../Components/AboutUs';
import AboutUs2 from '../Components/AboutUs2';
import Social from '../Components/Social';
import Social2 from '../Components/Social2';
import Private from '../Components/Private';
import Private2 from '../Components/Private2';
import Safe from '../Components/Safe';
import Safe2 from '../Components/Safe2';
import Safe3 from '../Components/Safe3';
import Intuitive from '../Components/Intuitive';
import Intuitive2 from '../Components/Intuitive2';
import Authentic from '../Components/Authentic';
import Footer from '../../Desktop/Components/Footer';

const Home = ({ onNavigate }) => {
  return (
    <main className={styles.home}>

      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Cover />
      </Suspense>

      {/* Wrap lazy components in Suspense with a fallback */}
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <AboutUs />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <AboutUs2 home={true} />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Social />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Social2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Private />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Private2 />
      </Suspense>
      {/* <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Safe />
      </Suspense> */}
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Safe2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Safe3 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Intuitive />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Intuitive2 />
      </Suspense>
      <Suspense fallback={<div style={{ height: '50vh' }} />}>
        <Authentic />
      </Suspense>
      <Footer onNavigate={onNavigate} />
    </main>
  );
};

export default Home;
